// Görevler panelini / iş kolunu sidebar dışına yüzen pencere olarak çıkarma
// için küçük store. Kalıcı (localStorage) + pub/sub. Aynı anda birden fazla
// iş kolu penceresi açılabilir; her kategori için tek pencere (dedupe).
const KEY = "sertex_detached_panels_v1";

let panels = load();
const subs = new Set();

function load() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
}

function persist() {
  try {
    localStorage.setItem(KEY, JSON.stringify(panels));
  } catch (e) {
    console.warn("[detachedPanels] persist failed:", e);
  }
  subs.forEach((cb) => cb(panels));
}

export function getDetachedPanels() {
  return panels;
}

export function subscribeDetachedPanels(cb) {
  subs.add(cb);
  return () => subs.delete(cb);
}

// category=null → tüm panel; category=<id> → o iş kolu penceresi.
export function openDetachedPanel({ category = null, categoryName = null } = {}) {
  const key = category || null;
  const existing = panels.find((p) => (p.category || null) === key);
  if (existing) return existing.id;
  const id = `dp_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
  panels = [...panels, { id, category: key, categoryName }];
  persist();
  return id;
}

export function closeDetachedPanel(id) {
  panels = panels.filter((p) => p.id !== id);
  persist();
}

// FAZ C — Düzen uygulanırken pencereler TEK seferde açılır. Geometri, panel
// listeye eklenMEDEN önce yazılır; böylece pencere mount olduğunda doğru
// konum/boyutla belirir (mevcut geometri mantığı aynen kullanılır).
export function openDetachedPanelsBatch(items = []) {
  const eklenecek = [];
  for (const it of items) {
    const key = it.category || null;
    if (panels.some((p) => (p.category || null) === key)) continue;
    if (eklenecek.some((p) => (p.category || null) === key)) continue;
    const id = `dp_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
    if (it.geom) savePanelGeom(id, it.geom);
    eklenecek.push({ id, category: key, categoryName: it.categoryName || null });
  }
  if (!eklenecek.length) return [];
  panels = [...panels, ...eklenecek];
  persist();
  return eklenecek.map((p) => p.id);
}

export function closeAllDetachedPanels() {
  if (!panels.length) return;
  panels = [];
  persist();
}

// --- Yüzen panel geometrisi (konum/boyut) ---
const GEOM_KEY = "sertex_detached_panel_geom_v1";
const PANEL_W = 460;
const PANEL_H = 620;
const MIN_VISIBLE = 140;

export function loadPanelGeom(id) {
  try {
    return JSON.parse(localStorage.getItem(GEOM_KEY) || "{}")[id] || null;
  } catch {
    return null;
  }
}

export function savePanelGeom(id, g) {
  try {
    const all = JSON.parse(localStorage.getItem(GEOM_KEY) || "{}");
    all[id] = g;
    localStorage.setItem(GEOM_KEY, JSON.stringify(all));
  } catch (e) {
    console.warn("[detachedPanels] geom save failed:", e);
  }
}

// AŞAMA 12 (Adım 3) — sürüklenerek dışarı alınan iş kolu penceresi bırakıldığı
// KOORDİNATA oturur (görev/alt görev pencereleriyle aynı −40/−20 ofseti).
// Kenarlarda en az 140 px görünür kalır.
export function placePanelAt(id, x, y) {
  const cx = Math.max(MIN_VISIBLE - PANEL_W, Math.min(window.innerWidth - MIN_VISIBLE, Math.round(x - 40)));
  const cy = Math.max(0, Math.min(window.innerHeight - MIN_VISIBLE, Math.round(y - 20)));
  savePanelGeom(id, { x: cx, y: cy, width: PANEL_W, height: PANEL_H });
  return { x: cx, y: cy };
}
